import React, {useEffect} from "react";
import {Button, Checkbox, Icon, Input, Layout, Radio, Tooltip} from "antd";
import "./Menu.scss";
import GuardedRenderer from "../../../../components/GuardedRenderer/GuardedRenderer";
import {useTranslation} from "react-i18next";
import {RadioChangeEvent} from "antd/es/radio";
import RadioGroup from "antd/es/radio/group";

const {TextArea} = Input;
const {Sider} = Layout;

export function Menu(props) {

    const {t} = useTranslation();

    useEffect(
        () => {
            if (!props.selectedImageEyeSide) {
                props.selectImage(props.eyeImages.filter(x => !x.loadFailed && x.eyeSide === 'right')[0]
                    || props.eyeImages.filter(x => !x.loadFailed && x.eyeSide === 'left')[0]);
            } else {
                props.selectImage(props.eyeImages.filter(x => !x.loadFailed &&
                    x.eyeSide === props.selectedImageEyeSide)[0] || props.eyeImages.filter(x => !x.loadFailed)[0]);
            }
        },
        [props.selectedImageEyeSide]
    )

    const renderFailedImage = (image) => {
        return (
            <Tooltip placement="right" title="No image" key={image.id}>
                <div className="image-data">
                    <div className={`eye-image disabled`}>
                        <Icon type="exception"/>
                        <div className="diagnosis">
                            {image.hasRetinopathy && <span>DR</span>}
                            {image.hasAmd && <span>AMD</span>}
                            {image.hasGlaucoma && <span>G</span>}
                            {image.gradable === false && <span>UNGR</span>}
                        </div>
                    </div>
                </div>
            </Tooltip>
        );
    }

    const renderImage = (image, isSelected, selectImageCallback) => {
        if (image.imageBlob) {
            var imageUrl = URL.createObjectURL(image.imageBlob);

            if (image.loadFailed)
                return renderFailedImage(image);

            return (
            /* {image.hasRetinopathy && <span>{t('common.diagnosis.DR')}</span>}
                                        */
                <div className="image-data" key={image.id}>
                    <div className={`eye-image ${isSelected && "selected"}`} onClick={() => selectImageCallback(image)}>
                        <img src={imageUrl} alt="eye"/>
                        <div className="diagnosis">
                            {<span className="eye-desease-proba">{image.deseaseProba}</span>}
                            {image.hasAmd && <span>{t('common.diagnosis.AMD')}</span>}
                            {image.hasGlaucoma && <span>{t('common.diagnosis.G')}</span>}
                        </div>
                    </div>
                    {
                        image.gradable === false &&
                        <div className="image-status">
                            <div className="error"><Icon type="close"/></div>
                        </div>
                    }
                </div>
            );
        }
    }

    const areDiagnosisControlsDisabled = (exam) => {
        return exam.examinationStatus === 'ANALYSING' || (!exam.rightEyeDiagnosis && !exam.leftEyeDiagnosis);
    }

    const changeEyeDiagnosis = (type, data) => {
        props.setExamEyeDiagnosisData(type, data);
    }

    const changeNote = (e) => {
        props.setDoctorNote(e.target.value);
    }

    const changeIccValue = (e)=> {
        // console.log("Menu.changeIccValue " + e.target.checked)
        // console.log("Menu.exam status: " + props.exam.examinationStatus)
        props.setIccValue(e.target.checked);
    }

    const changeAdvice = (e) => {
        props.setDoctorAdvice(e.target.value);
    }

    const renderUnavailableOverallResult = () => {
        return (
            <div>
                <p>Diagnosis data are not available now</p>
            </div>
        );
    }

    const renderOverallResult = (eyeDiagnosis, type, isDisabled) => {
        return (
            <div className="result" key={type}>
                <h3>{t('viewer.overallResult')}</h3>
                <div style={{display: "flex", alignItems: "start"}}>
                    <Tooltip placement="right" title={t('common.diagnosis.MaculopathyClassification')}>
                        <RadioGroup defaultValue={eyeDiagnosis ? eyeDiagnosis.maculopathyClassification : undefined}
                                    disabled={isDisabled}
                                    onChange={(e: RadioChangeEvent) => {
                                        changeEyeDiagnosis(type, {
                                            ...eyeDiagnosis,
                                            maculopathyClassification: e.target.value
                                        });
                                    }}>
                            <Radio value={0}>M0</Radio>
                            <Radio value={1}>M1</Radio>
                        </RadioGroup>
                    </Tooltip>
                    <Tooltip placement="right" title={t('common.diagnosis.RetinopathyClassification')}>
                        <RadioGroup defaultValue={eyeDiagnosis ? eyeDiagnosis.retinopathyClassification : undefined}
                                    disabled={isDisabled}
                                    onChange={(e: RadioChangeEvent) => {
                                        changeEyeDiagnosis(type, {
                                            ...eyeDiagnosis,
                                            retinopathyClassification: e.target.value
                                        });
                                    }}>
                            <Radio value={0}>R0</Radio>
                            <Radio value={1}>R1</Radio>
                            <Radio value={2}>R2</Radio>
                            <Radio value={3}>R3</Radio>
                        </RadioGroup>
                    </Tooltip>
                </div>
                <Tooltip placement="right" title={t('common.diagnosis.Ungradable')}>
                    <Checkbox checked={eyeDiagnosis && eyeDiagnosis.ungradable}
                              disabled={isDisabled}
                              onChange={(e) => {
                                  changeEyeDiagnosis(type, {
                                      ...eyeDiagnosis,
                                      ungradable: e.target.checked
                                  });
                              }}>
                        {t('common.diagnosis.Ungradable')}</Checkbox>
                </Tooltip>
            </div>
        );
    }

    const renderReadonlyDoctorResult = () => {
        return (<>
            <div className="overall-result">
                {
                    [(props.eyeImages && props.eyeImages.filter(image => image.eyeSide === 'right').length > 0 &&
                        renderOverallResult(props.exam.rightEyeDiagnosis, 'right', true)),
                        (props.eyeImages && props.eyeImages.filter(image => image.eyeSide === 'left').length > 0 &&
                            renderOverallResult(props.exam.leftEyeDiagnosis, 'left', true))
                    ]
                }
            </div>

            <div className="doctor-notes">
                <h3>{t('viewer.notes')}</h3>
                <TextArea
                    disabled={true}
                    value={props.exam.doctorNote}
                    onChange={changeNote}
                    maxLength="1000"
                    autoSize={{minRows: 5, maxRows: 15}}
                />
            </div>
            <div className="doctor-notes">
                <h3>{t('viewer.advice')}</h3>
                <TextArea
                    disabled={true}
                    value={props.exam.doctorAdvice}
                    onChange={changeAdvice}
                    maxLength="1000"
                    autoSize={{minRows: 5, maxRows: 15}}
                />
            </div>
        </>);
    }

    return (
        <Sider className="images-menu" width="350px">
            <div className="eye-data-container">
                {
                    props.eyeImages.filter(image => image.eyeSide === 'right').length > 0 && <div className="eye-data">
                        <div className="eye-header">
                            <h2>
                                {t('common.OD')}
                            </h2>

                            {
                                (props.eyeImages.some(image => image.eyeSide === 'right' && image.hasGroupRetinopathy === true && image.gradable === false) &&
                                <div className="eye-status">{t('common.diagnosis.DR')} + {t('viewer.notGradable')}</div>)
                                ||
                                (props.eyeImages.some(image => image.eyeSide === 'right' && image.gradable === false) &&
                                <div className="eye-status">{t('viewer.notGradable')}</div>)
                                ||
                                (props.eyeImages.some(image => image.eyeSide === 'right' && image.hasGroupRetinopathy === true) &&
                                <div className="eye-status">{t('common.diagnosis.DR')}</div>)
                                ||
                                (props.eyeImages.some(image => image.eyeSide === 'right' && image.hasGroupRetinopathy === false) &&
                                <div className="eye-status-green">{t('common.diagnosis.NoDR')}</div>)
                            }

                        </div>
                        {props.eyeImages.filter(image => image.eyeSide === 'right')
                            .map(image =>
                                {
                                    return renderImage(image, image === props.selectedImage, props.selectImage);
                                }
                            )}
                    </div>
                }
                {
                    props.eyeImages.filter(image => image.eyeSide === 'left').length > 0 && <div className="eye-data">
                        <div className="eye-header">
                            <h2>
                                {t('common.OS')}
                            </h2>

                            {
                                (props.eyeImages.some(image => image.eyeSide === 'left' && image.hasGroupRetinopathy === true && image.gradable === false) &&
                                <div className="eye-status">{t('common.diagnosis.DR')} + {t('viewer.notGradable')}</div>)
                                ||
                                (props.eyeImages.some(image => image.eyeSide === 'left' && image.gradable === false) &&
                                <div className="eye-status">{t('viewer.notGradable')}</div>)
                                ||
                                (props.eyeImages.some(image => image.eyeSide === 'left' && image.hasGroupRetinopathy === true) &&
                                <div className="eye-status">{t('common.diagnosis.DR')}</div>)
                                ||
                                (props.eyeImages.some(image => image.eyeSide === 'left' && image.hasGroupRetinopathy === false) &&
                                <div className="eye-status-green">{t('common.diagnosis.NoDR')}</div>)
                            }
                        </div>

                        {props.eyeImages.filter(image => image.eyeSide === 'left')
                            .map(image =>
                                {
                                    return renderImage(image, image === props.selectedImage, props.selectImage);
                                })
                        }
                    </div>
                }
            </div>
            {props.exam && <div className="exam-extra-info">
                {props.exam.isEyeDropUsed && <span>{t('viewer.eyeDrops')}</span>}
                {props.exam.isNoContradiction && <span>{t('viewer.contraindication')}</span>}
                {props.exam.isPatientDiabetic && <span>{t('viewer.diabetic')}</span>}
            </div>}
            <GuardedRenderer requiredFeature="PROCESS_EXAM"
                             fallbackComponent= {props.exam && renderReadonlyDoctorResult()}>
                {props.exam &&
                    <>
                        <div className="overall-result">
                            {(areDiagnosisControlsDisabled(props.exam))
                                ? renderUnavailableOverallResult()
                                : [(props.eyeImages && props.eyeImages.filter(image => image.eyeSide === 'right').length > 0 &&
                                    renderOverallResult(props.exam.rightEyeDiagnosis, 'right')),
                                    (props.eyeImages && props.eyeImages.filter(image => image.eyeSide === 'left').length > 0 &&
                                        renderOverallResult(props.exam.leftEyeDiagnosis, 'left'))
                                ]
                            }
                        </div>
                        <div className="result">
                            <Tooltip placement="right" title={t('viewer.icc')}>
                                <Checkbox
                                          disabled={areDiagnosisControlsDisabled(props.exam)}
                                          defaultChecked={ props.exam.examinationStatus === 'ICC'}
                                          onChange={changeIccValue}>
                                    {t('viewer.icc')}</Checkbox>
                            </Tooltip>
                        </div>
                        {!areDiagnosisControlsDisabled(props.exam) &&
                            <>
                                <div className="doctor-notes">
                                    <h3> {t('viewer.notes')}</h3>
                                    <TextArea
                                        disabled={areDiagnosisControlsDisabled(props.exam)}
                                        value={props.exam.doctorNote}
                                        onChange={changeNote}
                                        maxLength="1000"
                                        autoSize={{minRows: 5, maxRows: 15}}
                                    />
                                </div>
                                <div className="doctor-notes">
                                    <h3> {t('viewer.advice')}</h3>
                                    <TextArea
                                        disabled={areDiagnosisControlsDisabled(props.exam)}
                                        value={props.exam.doctorAdvice}
                                        onChange={changeAdvice}
                                        maxLength="1000"
                                        autoSize={{minRows: 5, maxRows: 15}}
                                    />
                                </div>
                                <div className="upload-button-container">
                                    <Button disabled={areDiagnosisControlsDisabled(props.exam)}
                                            className="upload-button" size="small" type="danger"
                                            onClick={props.saveExams}>
                                        {t('viewer.process')}
                                    </Button>
                                </div>
                            </>
                        }
                    </>
                }
            </GuardedRenderer>
        </Sider>
    )
}
